import '../../style/index.less';
import './index.less';
// style dependencies
// deps-lint-skip: menu
// deps-lint-skip: grid
import '../../button/style';
import '../../checkbox/style';
import '../../dropdown/style';
import '../../empty/style';
import '../../input/style';
import '../../pagination/style';
import '../../radio/style';
import '../../spin/style';
import '../../tooltip/style';
import '../../tree/style';
